module.exports = __webpack_public_path__ + "static/gallery17-dbc104935f20d3706cb0eaaf9c8349a7.jpg";